import React, { Fragment, useCallback, useEffect, useState } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import { Link, useParams } from "react-router-dom";
import { useGetJobQuery } from "../Store/api/JobListApi";
import { useApplyJobMutation } from "../Store/api/DataApi";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../Store";
import {
  error as Error,
  noPermissionAlert,
  success,
  waringMessage,
} from "../Services/CommonService";
import RelatedJobComponent from "../Components/Jobs/RelatedJobComponent";
import LoadingJobDetails from "../Components/Jobs/LoadingJobDetails";
import { actionLogout } from "../Store/slices/AuthSlice";

export default function JobDetails() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [relatedJob, setRelatedJob] = useState([]);
  const { data, error, isLoading } = useGetJobQuery(id);
  const { isAuth, profile } = useSelector((state: RootState) => state.auth);
  const [noJob, setNoJob] = useState(false);
  const [jobNature, setJobNature] = useState([]);
  const dispatch = useDispatch();

  const [applyJob] = useApplyJobMutation();

  const handleSetJobNature = useCallback(
    (data) => {
      let jN = [];
      if (data?.full_time === "Yes") jN.push("Full-Time");
      if (data?.part_time === "Yes") jN.push("Part-Time");
      if (data?.wfh === "Yes") jN.push("Work From Home");
      if (data?.intership === "Yes") jN.push("Internship");

      setJobNature(jN);
    },
    [setJobNature]
  );

  useEffect(() => {
    if (data?.data) {
      setNoJob(false);

      setJob(data?.data);
      setRelatedJob(data?.relatedJobs);
      handleSetJobNature(data?.data);

      setTimeout(() => {
        window.$(".active-relatedjob-carusel").owlCarousel({
          items: 1,
          autoplay: data?.relatedJobs?.length > 1 ? true : false,
          loop: data?.relatedJobs?.length > 1 ? true : false,
          margin: 30,
          dots: true,
        });
      }, 500);
    }

    if (error?.status === 404) {
      setNoJob(true);
    }
  }, [data, error, handleSetJobNature]);

  const handleApply = useCallback(() => {
    //console.log(profile);

    if (isAuth && (profile?.lgbt_status === 1 || profile?.lgbt_status === 3)) {
      applyJob(id)
        .then((res) => {
          //  if (res.error) {
          //    Error(res.error.data.error);
          //  } else {
          //    success(res?.data?.message);
          //  }
          if (res?.error?.data?.error !== undefined) {
            Error(res?.error?.data?.error);
          } else if (res.data?.error !== undefined) {
            Error(res.data?.error);
            if (res.data?.error === "Invalid token!") {
              dispatch(actionLogout());
            }
          } else {
            success(res?.data?.message);
          }
        })
        .catch((err) => {
          console.log(err);
          error(err?.error?.data?.error);
        });
    } else if (isAuth && profile?.lgbt_status === 0) {
      noPermissionAlert();
    } else {
      waringMessage("Apply Job");
    }
  }, [id, applyJob, isAuth, profile, dispatch, error]);

  return (
    <Fragment>
      <PageBannerComponent title="Job Details" />
      {/* Start post Area */}
      <section className="post-area section-gap">
        {job?.id && (
          <div className="container">
            <div className="header-detail">
              <div className="header-content pull-left">
                <h3>{job?.job_title}</h3>
                <p>
                  <span>Date Posted: {job?.job_publish_schedule}</span>
                </p>
                <p>
                  Monthly Salary:{" "}
                  <strong className="price">{job?.job_ctc}</strong>
                </p>
              </div>

              <div className="detail-company pull-right text-right">
                {
                  <div className="img-thum">
                    {job?.profile_image ? (
                      <img
                        className="img-responsive"
                        width="100%"
                        src={data?.path + encodeURI(job?.profile_image)}
                        alt=""
                      />
                    ) : (
                      <img
                        className="img-responsive"
                        width="100%"
                        src={data?.path + "hiring.jpeg"}
                        alt=""
                      />
                    )}
                  </div>
                }
                <div className="name">
                  <h4>{job?.company_name}</h4>
                  {/* <h5>New York, NY</h5> */}
                  <p>
                    {`Current jobs ${
                      Number(job?.job_position) > 1 ? "openings" : "opening"
                    } : ` + job?.job_position}
                  </p>

                  {!isAuth && (
                    <button onClick={handleApply} className={`btn btn-info`}>
                      Quick Apply
                    </button>
                  )}
                  {isAuth && (
                    <button
                      onClick={
                        profile?.lgbt_status === 1 || profile?.lgbt_status === 3
                          ? handleApply
                          : () => {}
                      }
                      className={`btn btn-info ${
                        profile?.lgbt_status === 1 || profile?.lgbt_status === 3
                          ? ""
                          : "disabled"
                      }`}
                    >
                      Quick Apply
                    </button>
                  )}
                </div>
              </div>

              {/* <div className="clearfix" /> */}
            </div>
            <div className="row justify-content-center d-flex">
              <div className="col-lg-8 post-list">
                <div className="single-post job-details">
                  <h4 className="single-title">Job Description</h4>
                  <p dangerouslySetInnerHTML={{ __html: job?.job_details }}></p>
                </div>
                <div className="single-post job-experience">
                  <h4 className="single-title">Qualification</h4>
                  {job?.min_experience !== 0 && (
                    <p>
                      Minimum of {job?.min_experience} years experience.
                      Qualified candidates for this role will possess the
                      following skills:
                    </p>
                  )}
                  <ul>
                    <li>
                      <img
                        src={require("../Assets/img/pages/list.jpg")}
                        alt=""
                      />{" "}
                      <span>{job?.skills}</span>
                    </li>
                  </ul>
                  {/* <p>{job?.skills}</p> */}
                  {/* <ul>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Demonstrated strong and effective verbal, written, and
                      interpersonal communication skills
                    </span>
                  </li>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Must be team-oriented, possess a positive attitude and
                      work well with others
                    </span>
                  </li>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Ability to prioritize and multi-task in a flexible, fast
                      paced and challenging environment
                    </span>
                  </li>
                </ul> */}
                  <hr />
                  {/* <h4 className="single-title">
                  Key responsibilities also include
                </h4>
                <ul>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Provide technical health advice to Head of Country
                      Programmes and field advisors at all key stages of the
                      project management cycle including needs assessment.
                    </span>
                  </li>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Technical strategy and design, implementation as well as
                      sector specific monitoring and evaluation.
                    </span>
                  </li>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      This includes travel to field programmes as well as review
                      of proposals, key reports and surveys prior to external
                      submission.
                    </span>
                  </li>
                </ul>
                <hr />
                <h4 className="single-title">Requirements</h4>
                <ul>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Must have minimum of 3 years experience running,
                      maneuvering, driving, and navigating equipment such as
                      bulldozer, excavators, rollers, and front-end loaders.
                    </span>
                  </li>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Must have minimum of 3 years experience running,
                      maneuvering, driving, and navigating equipment such as
                      bulldozer, excavators, rollers, and front-end loaders.
                      Strongly prefer candidates with High School Diploma
                    </span>
                  </li>
                </ul>
                <hr />
                <h4 className="single-title">Benefits</h4>
                <ul>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Must have minimum of 3 years experience running,
                      maneuvering, driving, and navigating equipment such as
                      bulldozer, excavators, rollers, and front-end loaders.
                    </span>
                  </li>
                  <li>
                    <img src="img/pages/list.jpg" alt="" />
                    <span>
                      Strongly prefer candidates with High School Diploma
                    </span>
                  </li>
                </ul> */}
                  {job?.id && (
                    <Link
                      to="#"
                      onClick={
                        profile?.lgbt_status === 3 ? () => {} : handleApply
                      }
                      className={`btn genric-btn info circle ${
                        profile?.lgbt_status === 3 ? "disabled" : ""
                      }`}
                    >
                      Apply for this Job Now
                    </Link>
                  )}
                </div>
              </div>
              <div className="col-lg-4 sidebar">
                <div className="single-slidebar">
                  <h4>Job Details</h4>
                  <ul className="detail-list">
                    <li className="d-flex justify-content-between">
                      <Link to="">Job Id:</Link>
                      <span className="type-posts text-right">{job?.id}</span>
                    </li>
                    <li className="d-flex justify-content-between">
                      <Link to="">Work Experience:</Link>
                      <span className="type-posts text-right">
                        {job?.min_experience ?? "0"} years
                      </span>
                    </li>
                    {/* <li>
                    <Link to="">Education Qualification:</Link>
                    <span className="type-posts">MBA</span>
                  </li> */}
                    <li className="d-flex justify-content-between">
                      <Link to="">Location:</Link>
                      <span className="type-posts text-right">
                        {job?.locations}
                      </span>
                    </li>
                    <li className="d-flex justify-content-between">
                      <Link to="">Application Deadline:</Link>
                      <span className="type-posts text-right">
                        {job?.application_deadline}
                      </span>
                    </li>
                    {/* <li>
                    <Link to="">Employment Status</Link>
                    <span className="type-posts">Permanent/Temporary</span>
                  </li> */}
                    <li className="d-flex justify-content-between">
                      <Link to="">Employment Type:</Link>
                      <span className="type-posts text-right">
                        {jobNature.join(", ")}
                      </span>
                    </li>
                  </ul>
                </div>
                {relatedJob.length > 0 && (
                  <div className="single-slidebar">
                    <h4>Related Jobs</h4>
                    <div className="active-relatedjob-carusel">
                      {relatedJob.map((job, i) => (
                        <RelatedJobComponent
                          item={job}
                          path={data?.path}
                          key={i}
                        />
                      ))}
                      {/* <div className="single-rated">
                    <img
                      className="img-fluid"
                      src={require("../Assets/img/r1.jpg")}
                      alt=""
                    />
                    <Link to="single">
                      <h4>Creative Art Designer</h4>
                    </Link>
                    <h6>Premium Labels Limited</h6>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod temporinc ididunt ut dolore magna aliqua.
                    </p>
                    <h5>Job Nature: Full time</h5>
                    <p className="address">
                      <span className="lnr lnr-map" /> 56/8, Panthapath
                      Dhanmondi Dhaka
                    </p>
                    <p className="address">
                      <span className="lnr lnr-database" /> 15k - 25k
                    </p>
                    <Link to="" className="btns text-uppercase">
                      Apply job
                    </Link>
                  </div>
                  <div className="single-rated">
                    <img
                      className="img-fluid"
                      src={require("../Assets/img/r1.jpg")}
                      alt=""
                    />
                    <Link to="single">
                      <h4>Creative Art Designer</h4>
                    </Link>
                    <h6>Premium Labels Limited</h6>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod temporinc ididunt ut dolore magna aliqua.
                    </p>
                    <h5>Job Nature: Full time</h5>
                    <p className="address">
                      <span className="lnr lnr-map" /> 56/8, Panthapath
                      Dhanmondi Dhaka
                    </p>
                    <p className="address">
                      <span className="lnr lnr-database" /> 15k - 25k
                    </p>
                    <Link to="" className="btns text-uppercase">
                      Apply job
                    </Link>
                  </div>
                  <div className="single-rated">
                    <img
                      className="img-fluid"
                      src={require("../Assets/img/r1.jpg")}
                      alt=""
                    />
                    <Link to="single">
                      <h4>Creative Art Designer</h4>
                    </Link>
                    <h6>Premium Labels Limited</h6>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod temporinc ididunt ut dolore magna aliqua.
                    </p>
                    <h5>Job Nature: Full time</h5>
                    <p className="address">
                      <span className="lnr lnr-map" /> 56/8, Panthapath
                      Dhanmondi Dhaka
                    </p>
                    <p className="address">
                      <span className="lnr lnr-database" /> 15k - 25k
                    </p>
                    <Link to="" className="btns text-uppercase">
                      Apply job
                    </Link>
                  </div> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {isLoading && <LoadingJobDetails />}

        {noJob && (
          <div className="container">
            <div className="header-detail">
              <h4 className="p-4 text-center">Requested job not found.</h4>
            </div>
          </div>
        )}
      </section>
      {/* End post Area */}
    </Fragment>
  );
}
